import { Directive, OnDestroy, OnInit } from '@angular/core';
import { UserIdleService } from '../services/user-idle.service';

@Directive({ selector: '[posPauseIdleLogOut]' })
export class PauseIdleLogOutDirective implements OnInit, OnDestroy {

  constructor(private userIdleService: UserIdleService) { }

  ngOnInit(): void {
    this.userIdleService.enablePause();
  }

  ngOnDestroy(): void {
    this.userIdleService.disablePause();  
  }
}
